import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Field, getId } from '../Field/Field';
import { textInputWidth } from '../Field/Field.styled';
import { FieldError } from '../Field/FieldError';
import { formErrorAttribute } from '../Form';
import { withInputContext } from '../Form/withInputContext';
import { withTranslate } from '../util';
import { forwardDataAttributes, setDataAttributes } from '../util/getDataAttributes';
import { Hint } from './Hint';
import { StyledInput, StyledTextInputIcon, StyledTextInputInnerWrapper, StyledTextInputSecondaryIcon, StyledTextInputWrapper } from './TextInput.styled';
export function TextField(props) {
  var id = getId(props);
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    htmlFor: id
  }), /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    maxWidth: props.maxWidth ? '100%' : textInputWidth,
    id: id
  })));
}
var _TextInput = /*#__PURE__*/function (_React$Component) {
  function _TextInput() {
    var _this;
    _classCallCheck(this, _TextInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _TextInput, [].concat(args));
    _defineProperty(_this, "state", {
      inputInFocus: false
    });
    _defineProperty(_this, "handleRef", function (input) {
      if (_this.props.inputRef) {
        _this.props.inputRef(input);
      }
    });
    _defineProperty(_this, "onBlur", function (e) {
      if (!_this.props.disableValidationOnBlur) {
        _this.props.inputContext.makeDirty();
      }
      if (_this.props.asyncValidate) {
        _this.asyncValidate();
        return;
      }
      _this.props.onBlur && _this.props.onBlur(e.currentTarget.value, e);
    });
    _defineProperty(_this, "asyncValidate", function () {
      return Promise.resolve(_this.props.asyncValidate(_this.props.value));
    });
    _defineProperty(_this, "onChange", function (e) {
      if (_this.props.validateOnChange) {
        _this.props.inputContext.makeDirty();
      }
      _this.props.onChange && _this.props.onChange(e.currentTarget.value);
      _this.props.onChangeEvent && _this.props.onChangeEvent(e);
    });
    _defineProperty(_this, "onClick", function (e) {
      _this.props.onClick && _this.props.onClick();
      _this.props.onClickEvent && _this.props.onClickEvent(e);
    });
    return _this;
  }
  _inherits(_TextInput, _React$Component);
  return _createClass(_TextInput, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$props$value;
      var t = this.props.t;
      var requiredError = this.props.required && (!this.props.value || !this.props.value.trim()) ? t('citrix-ui:validation.enter_required_value') : undefined;
      var isErrored = !this.props.disabled && (!!this.props.errorMessage || !!requiredError);
      var showError = this.props.inputContext.isDirty && isErrored;
      var showWarning = !this.props.disabled && this.props.inputContext.isDirty && !!this.props.warningMessage;
      var wrapperStyle = {
        maxWidth: this.props.maxWidth
      };
      var inputStyle = {
        textAlign: this.props.textAlign
      };
      return /*#__PURE__*/React.createElement(StyledTextInputWrapper, {
        style: wrapperStyle
      }, this.props.icon && /*#__PURE__*/React.createElement(StyledTextInputIcon, null, this.props.icon), /*#__PURE__*/React.createElement(StyledTextInputInnerWrapper, {
        inputInFocus: this.state.inputInFocus,
        showError: showError,
        showWarning: showWarning
      }, /*#__PURE__*/React.createElement(StyledInput, _extends({
        type: this.props.type || 'text',
        id: this.props.id,
        style: inputStyle,
        hasIcon: !!this.props.icon,
        hasSecondaryIcon: !!this.props.secondaryIcon,
        maxLength: this.props.maxLength,
        autoFocus: !!this.props.autoFocus,
        placeholder: this.props.placeholder,
        value: this.props.value || '',
        onBlur: function onBlur(event) {
          _this2.setState({
            inputInFocus: false
          });
          _this2.onBlur(event);
        },
        onKeyDown: this.props.onKeyDown,
        onKeyUp: this.props.onKeyUp,
        autoComplete: this.props.autoComplete,
        autoCapitalize: this.props.autoCapitalize,
        autoCorrect: this.props.autoCorrect,
        spellCheck: this.props.spellCheck,
        disabled: !!this.props.disabled,
        onChange: this.onChange,
        onClick: this.onClick,
        readOnly: this.props.readOnly,
        ref: this.handleRef,
        onFocus: function onFocus(event) {
          var _this2$props$onFocus, _this2$props;
          _this2.setState({
            inputInFocus: true
          });
          (_this2$props$onFocus = (_this2$props = _this2.props).onFocus) === null || _this2$props$onFocus === void 0 ? void 0 : _this2$props$onFocus.call(_this2$props, event);
        },
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby']
      }, setDataAttributes(this.props, 'textinput'), formErrorAttribute(isErrored))), this.props.secondaryIcon && /*#__PURE__*/React.createElement(StyledTextInputSecondaryIcon, null, this.props.secondaryIcon)), /*#__PURE__*/React.createElement(FieldError, _extends({
        htmlFor: this.props.id,
        error: showError ? this.props.errorMessage || requiredError : undefined,
        warning: showWarning ? this.props.warningMessage : undefined,
        alertAction: this.props.alertAction
      }, forwardDataAttributes(this.props))), /*#__PURE__*/React.createElement(Hint, _extends({
        hint: this.props.hint,
        showCharacterLimit: this.props.showCharacterLimit,
        currentLength: (_this$props$value = this.props.value) === null || _this$props$value === void 0 ? void 0 : _this$props$value.length,
        maxLength: this.props.maxLength
      }, forwardDataAttributes(this.props))));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.asyncValidate) {
        this.props.inputContext.registerValidator(this.asyncValidate);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.asyncValidate) {
        this.props.inputContext.unregisterValidator();
      }
    }
  }]);
}(React.Component);
export var TextInput = withInputContext(withTranslate(_TextInput));